<template>
    <div class="main_container">
      <div class="container-fluid edit-story-wrapper" :class="selectedNodeType">
        <!-- Tools bar contains 2 divs -->
          <div class="panel-wrapper">
            <div class="card">
              <div class="simulation-controls">
                <div class="btn">
                  <i class="fas fa-backward fa-xl"></i>
                </div>
                <div class="btn">
                  <i class="fas fa-step-backward fa-xl"></i>
                </div>
                <div @click="hidePlayAndPause" class="btn">
                  <svg id="pause_SVG" width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.63068 20.0757C1.2967 20.0757 0.215942 18.9949 0.215942 17.661V2.56684C0.215942 1.23286 1.2967 0.1521 2.63068 0.1521C3.96465 0.1521 5.04541 1.23286 5.04541 2.56684V17.661C5.04661 18.9949 3.96465 20.0757 2.63068 20.0757Z" fill="white"/>
                  <path d="M12.2908 20.0757C10.9569 20.0757 9.8761 18.9949 9.8761 17.661V2.56684C9.8761 1.23286 10.9569 0.1521 12.2908 0.1521C13.6248 0.1521 14.7057 1.23286 14.7057 2.56684V17.661C14.7057 18.9949 13.6248 20.0757 12.2908 20.0757Z" fill="white"/>
                  </svg>
                  <!--  -->
                  <svg id="play_SVG" width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.30087 1.48069C0.292522 1.10347 0.689048 0.853279 1.02593 1.02321L23.8373 12.5298C24.1843 12.7048 24.2076 13.1916 23.8789 13.399L1.63277 27.4354C1.30402 27.6428 0.874685 27.4122 0.866086 27.0236L0.30087 1.48069Z" fill="white"/>
                  </svg>
                </div>
                <div class="btn">
                  <i class="fas fa-step-forward fa-xl"></i>
                </div>
                <div class="btn">
                  <i class="fas fa-forward fa-xl"></i>
                </div>
              </div>
                <div class="card-header">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span
                      ><i class="fas fa-video"></i>
                      Preview</span
                    >
                  </div>
                </div>
                <div class="card-body p-0 position-relative" ref="preview">
                    <previewComponent
                    :height="height"
                    :width="width"
                    :showShadow="showShadow"
                    :showSkeleton="showSkeleton"
                    :selectedAnimation="selectedAnimation"
                    :selectedFbxModel="selectedFbxModel"
                  /> 
                </div>
            </div>
          </div>
      </div>
    </div>
</template>
<script>
import StoryViewHeader from "../components/v2/story-edit-view/header";
import logicComponent from "../components/v2/story-edit-view/logic";
import previewComponent from "../components/v2/story-edit-view/newPreview";
import { mapState } from "vuex";
export default {
  components: {
    StoryViewHeader,
    previewComponent,
    logicComponent,
  },
  computed: {
    ...mapState(["characters"]),
  },
  data() {
    return {
      componentType: "Timeline",
      isPanelOpen: {
        logic: true,
        preview: true,
        inspector: true,
      },
      isPanelExpanded: {
        logic: false,
        preview: false,
      },
      layout_type: "default",
      showShadow: true,
      height: 100,
      width: 100,
      selectedAnimation: 0,
      showSkeleton: false,
      selectedFbxModel: 0,
      openComponentType: null,
      selectedNodeType: "",
    };
  },
  created() {
    //this.$on('openModalsComponent', this.showModelsComponent)
    if (!localStorage.getItem("storyId")) {
      this.$router.push("/newprofile/projects");
    }
    this.selectedLogic = JSON.parse(localStorage.getItem("selectedLogic"));
  },
  watch: {
    layout_type: function () {
      this.resizePreview();
    },
  },
  mounted() {
    if (this.$route.params.category) {
      this.componentType = this.$route.params.category;
    }
    this.resizePreview();
    if (this.$store.state.selectedLogic.category) {
      this.selectedNodeType =
        this.$store.state.selectedLogic.category.toLowerCase();
    }
  },
  methods: {
    hidePlayAndPause() {
      const playSVG = document.getElementById("play_SVG");
      const pauseSVG = document.getElementById("pause_SVG");

      if (playSVG.style.display == 'none') {
        pauseSVG.style.display = 'none'
        playSVG.style.display = 'block'
      } else {
        playSVG.style.display = 'none'
        pauseSVG.style.display = 'block'
      }
    },
    expandPanel(type) {
      switch (type) {
        case "logic":
          this.isPanelExpanded.logic = !this.isPanelExpanded.logic;
          break;
        case "preview":
          this.isPanelExpanded.preview = !this.isPanelExpanded.preview;
          this.resizePreview();
          break;
      }
    },
    closePanel(type) {
      this.isPanelExpanded.logic = false;
      this.isPanelExpanded.preview = false;

      switch (type) {
        case "logic":
          this.isPanelOpen.logic = false;
          this.resizePreview();
          break;
        case "preview":
          this.isPanelOpen.preview = false;
          break;
        case "inspector":
          this.isPanelOpen.inspector = false;
          break;
      }
    },
    togglePanel(type) {
      this.isPanelExpanded.logic = false;
      this.isPanelExpanded.preview = false;
      switch (type) {
        case "logic":
          this.isPanelOpen.logic = !this.isPanelOpen.logic;
          break;
        case "preview":
          this.isPanelOpen.preview = !this.isPanelOpen.preview;
          break;
        case "inspector":
          this.isPanelOpen.inspector = !this.isPanelOpen.inspector;
          break;
      }
      this.resizePreview();
    },
    showShadowChange(data) {
      this.showShadow = data.showShadow;
    },
    showSkeletonChange(data) {
      this.showSkeleton = data.showSkeletonToggle;
    },
    showSelectedAnimation(data) {
      this.selectedAnimation = data.selectedAnimation;
    },
    showSelectedModel(data) {
      this.selectedFbxModel = data.selectedFbxModel;
    },
    openComponent(data) {
      this.openComponentType = data;
    },
    
  },
};
</script>
<style lang="scss" scoped>
/* only wrote css for specific target */
@import "../../external_libs/frame.js/editor/css/dark.css";
@import "../../external_libs/frame.js/editor/css/main.css";

.edit-story-wrapper {
    background: #111313;
    min-height: auto;
    color: #e7e7e7;
    padding: 0px;
    position: relative;
    height: calc(100vh - 64px);
    min-height: auto;
}

.edit-story-wrapper .panel-wrapper {
    margin-right: 0;
    margin-left: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    justify-content: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    position: relative;
    height: 100%;
}

.edit-story-wrapper .panel-wrapper>[class*="col"] {
    margin: 0;
    padding: 0;
}

.card {
    height: 100%;
    width: 100%;
}

#unity-container, #unity-canvas {
    position: relative;
    width: 100%;
    height: 100%;
}

.edit-story-wrapper .card-header {
    display: none;
}

.card .simulation-controls {
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px;
  background: transparent;
  display: none;
  align-items: center;
  justify-content: space-evenly;
  z-index: 1;

  .btn {
    color: white;
    border-radius: 50%;
    background-color: #47b784;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 10px;
    width: 50px;
    height: 50px;
    margin: 10px;
    &:hover {
      background-color: #55d59b;
    }

    &:nth-child(3) {
      width: 64px;
      height: 64px;
    }

    svg {
      width: 20px;
      height: 20px;
    }

    #play_SVG {
      display: none;
    }
  }
}
@media screen and (min-width: 821px) {
  .card .simulation-controls {
    display: flex;
  }
}

@media screen and (max-width: 820px) {
  #unity-container, #unity-canvas {
    // 118px is the calcule of the tob mobile nad bottom bar width
    height: calc(100vh - 118px) !important
  }
  .edit-story-wrapper .panel-wrapper .logic-wrap {
    display: none;
  }
  .row {
    display: none;
  }
  .edit-story-wrapper .panel-wrapper .inspector-wrap {
    display: none;
  }
  .edit-story-wrapper .close-btn {
    display: none;
  }
  .edit-story-wrapper .card-header {
    display: none;
  }
  .edit-story-wrapper .card-action-buttons {
    display: none;
  }
  .edit-story-wrapper .panel-wrapper>[class*="col"] {
      margin-bottom: 0;
  } 
  .edit-story-wrapper {
      padding: 0;
  }
  .container, .container-fluid, .container-sm, .container-md, .container-lg, .container-xl {
      width: 100%;
      padding-right: 0;
      padding-left: 0;
  }
  .edit-story-wrapper .card-body {
    height: 100%; 
  }
  .card {
      // border: none;
      border-radius: 0.0rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/simulation.vue